import Api from '@/Api'

export default class LoginApi extends Api {
  /**
   * Retrieves details about a member given options.memberCk is defined
   * @param {Object}          [options={}] - configuration for the API request
   * @param {Number}          options.body.memberCk - the member's CK
   * @param {Object}          options.params - key/value pairs to be provided as url query parameters
   */
  getMemberDetails = (options = {}) => {
    return this.post(`/api/v1/private/members/detail`, options.params)
  }

  /**
   * Requests the Member Edit API service to mail the ID cards of the member given options.memberCk is defined
   * @param {Object}          [options={}] - configuration for the API request
   * @param {Number}          options.body.memberCk - the member's ID
   * @param {Object}          options.params - key/value pairs to be provided as url query parameters
   */
  mailMemberIdCards = (options = {}) => {
    return this.post(`/api/v1/private/members/cards`, options.body)
  }

  /**
   * Requests the Member Edit API service for a list of known addresses for the member given options.memberCk is defined
   * @param {Object}          [options={}] - configuration for the API request
   * @param {Number}          options.body.memberCk - the member's CK
   * @param {Object}          options.params - key/value pairs to be provided as url query parameters
   */
  getMemberAddresses = (options = {}) => {
    return this.post(`/api/v1/private/members/addresses`, options)
  }

  /**
   * Add member coverage
   * @param {Object}          options - configuration for the API request
   * @param {Object}          options.body - the request body
   */
  addCoverage = (options = {}) => {
    return this.put(`/api/v1/private/members/coverages/add`, options.body)
  }

  /**
   * Update member coverage
   * @param {Object}          options - configuration for the API request
   * @param {Object}          options.body - the request body
   */
  updateCoverage = (options = {}) => {
    return this.put(`/api/v1/private/members/coverages/update`, options.body)
  }

  /**
   * Update original enrollment date
   * @param {Object}          options - configuration for the API request
   * @param {Object}          options.body - the request body
   */
  updateEnrollmentDate = (options = {}) => {
    return this.put(`/api/v1/private/members/coverages/enrollments`, options.body)
  }

  /**
   * Void member coverage
   * @param {Object}          options - configuration for the API request
   * @param {Object}          options.body - the request body
   */
  voidMember = (options = {}) => {
    return this.delete(`/api/v1/private/members/coverages/void`, options.body)
  }
}
